import * as React from 'react';
import styles from './button.module.scss';

import { ButtonProps } from './button.props';
import classNames from 'classnames';

/**
 * Renders Button
 */
const Button: React.FC<ButtonProps> = ({
  icon,
  onClick,
  classes,
  children,
  border = true,
  type = 'button',
  disabled = false,
  variant = 'default',
}) => (
  <button
    className={classNames(
      styles.button,
      {
        [styles.buttonDisabled]: disabled,
        [styles.buttonOutlined]: variant === 'outlined',
        [styles.buttonText]: variant === 'text',
        [styles.buttonBorder]: border,
      },
      classes,
    )}
    type={type}
    onClick={onClick && onClick}
    disabled={disabled}
  >
    {children}
    {icon && icon}
  </button>
);

export { Button };
